export default __webpack_public_path__ + "static/media/logoMVCDark.64b679a5.png";